import { useState, type FormEvent } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [statusMsg, setStatusMsg] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = (formData.get('website_alt') as string || '').trim();
    if (honeypot) {
      setStatus('success');
      setStatusMsg('订阅成功！感谢你的关注~');
      return;
    }

    setStatus('loading');
    try {
      const body = new URLSearchParams();
      formData.forEach((value, key) => {
        if (key !== 'website_alt' || !(value as string).trim()) {
          body.append(key, value as string);
        }
      });

      const res = await fetch('https://readdy.ai/api/form/d9spcctlbrt1qcgaj7hg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });

      const text = await res.text();
      let parsed;
      try { parsed = JSON.parse(text); } catch { parsed = null; }

      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setStatusMsg('订阅成功！感谢你的关注~');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || text;
        if (serverMsg.includes('spam')) {
          setStatus('error');
          setStatusMsg('提交失败，请稍后再试。');
        } else {
          setStatus('error');
          setStatusMsg(serverMsg || '订阅失败，请稍后再试。');
        }
      }
    } catch {
      setStatus('error');
      setStatusMsg('网络错误，请稍后重试。');
    }
  };

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-accent-500">
      <div className="max-w-2xl mx-auto text-center">
        <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-5 rounded-full bg-background-50/20 flex items-center justify-center">
          <i className="ri-mail-send-line text-2xl md:text-3xl text-background-50"></i>
        </div>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3">
          订阅我们的旅行周报
        </h2>
        <p className="text-background-200 text-sm md:text-base mb-8 max-w-md mx-auto">
          每周精选最新韩国旅行攻略、优惠信息和热门活动，直接送到你的邮箱
        </p>

        <form
          onSubmit={handleSubmit}
          data-readdy-form
          className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
        >
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="输入你的邮箱地址"
            required
            className="flex-1 px-5 py-3 rounded-full bg-background-50 text-foreground-800 placeholder:text-foreground-400 text-sm outline-none border-2 border-transparent focus:border-accent-300 transition-colors"
          />
          <input
            type="text"
            name="website_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="form-honeypot"
          />
          <button
            type="submit"
            disabled={status === 'loading'}
            className="px-8 py-3 bg-foreground-900 hover:bg-foreground-800 text-background-50 font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer text-sm disabled:opacity-60"
          >
            {status === 'loading' ? '订阅中...' : '免费订阅'}
          </button>
        </form>

        {status === 'success' && (
          <p className="mt-4 text-sm text-background-100">{statusMsg}</p>
        )}
        {status === 'error' && (
          <p className="mt-4 text-sm text-background-100">{statusMsg}</p>
        )}
      </div>
    </section>
  );
}